/**
 * @module app.router
 */


/**
 * @param {!app.config.stateservice} appConfigStateService
 * @return {!angular.$q.Promise<appx.UserSettings>}
 * @ngInject
 */
const resolveUserSettings = function(appConfigStateService) {
  return appConfigStateService.getUserSettings();
};

/**
 * @param {!app.CesiumLoader} appCesiumLoader
 * @ngInject
 */
const not3d = function(appCesiumLoader) {
  return appCesiumLoader.not3d();
};


/**
 * @ngInject
 * @param {ui.router.$stateProvider} $stateProvider
 * @param {ui.router.$urlRouterProvider} $urlRouterProvider
 * @param {angular.$locationProvider} $locationProvider
 */
const router = function($stateProvider, $urlRouterProvider, $locationProvider) {
  // TODO: Investigate the issue why URL does not change dynamically
  //       Maybe some issue that we change URL params manually
  $locationProvider.html5Mode({
    enabled: false
  });

  const home = {
    name: 'home',
    url: '/',
    views: {
    }
  };

  const userRoutes = [{
    name: 'user',
    url: '/user',
    views: {
      'mytracks': {
        template:
          `<div class="menu-item-body menu-user-container">
             <app-user></app-user>
           </div>`
      }
    }
  }];

  const trackRoutes = [{
    name: 'track-list',
    url: '/track-list',
    views: {
      'mytracks': {
        template:
          `<app-track-list
             on-select-track="$ctrl.selectTrack(track, type, {clear: true})"
             selected-track-id="$ctrl.selectedTrackId"
             track-list="$ctrl.tracks_list">
           </app-track-list>`
      }
    }
  }, {
    name: 'track-facts',
    url: '/track-facts',
    views: {
      'mytracks': {
        template:
          `<div class="menu-item-body track-facts">
             <div class="error-msg" ng-show="$ctrl.factsError" translate>
               The facts and the profile cannot be shown, because the tour is too long.
             </div>
             <app-track-facts on-set-timetype="$ctrl.setTimetype(timetype)"></app-track-facts>
             <app-track-profile type="light"></app-track-profile>
           </div>
           <div ng-include="'js/app/track/show/partial.html'"></div>`
      }
    }
  }, {
    name: 'track-edit',
    url: '/track-edit',
    onEnter: not3d,
    params: {
      'create': true
    },
    views: {
      'mytracks': {
        template:
          `<div ng-include="'js/app/track/edit/partial-top.html'"></div>
           <div class="menu-item-body track-facts">
             <div class="error-msg" ng-show="$ctrl.factsError" translate>
               The facts and the profile cannot be shown, because the tour is too long.
             </div>
             <div class="loading" ng-show="$ctrl.factsLoading">
               <div class="loading-spinner"></div>
             </div>
             <app-track-facts on-set-timetype="$ctrl.setTimetype(timetype)"></app-track-facts>
             <app-track-profile type="light"></app-track-profile>
           </div>
           <app-track-edit
             modify-feature="$ctrl.modifyFeature"
             on-geometry-changed="$ctrl.refreshFacts(line, heightProfile)"
             on-init-drawing="$ctrl.initDrawing(create, $resolve.userSettings)"
             on-cancel-drawing="$ctrl.cancelDrawing()"
             on-save-drawing="$ctrl.saveDrawing(line, controlPoints)"
             user-settings="$resolve.userSettings"
             facts-loading="$ctrl.factsLoading"
             request-info-for-geom="$ctrl.requestInfoForGeom">
           </app-track-edit>`
      },
      'bottom': {
        component: 'appTrackMobileDrawing'
      }
    },
    resolve: {
      'userSettings': resolveUserSettings
    }
  }, {
    name: 'track-poi',
    url: '/track-poi',
    onEnter: not3d,
    params: {
      'activePOI': null
    },
    views: {
      'mytracks': {
        template:
          `<app-tracks-poi class="tracks-poi"
             tracks-ctrl="$ctrl"
             on-poi-changed="$ctrl.poiChanged(activePOI)">
           </app-tracks-poi>`
      },
      'bottom': {
        component: 'appTrackPoiEditMobile'
      }
    }
  }, {
    name: 'track-print',
    url: '/track-print',
    onEnter: not3d,
    views: {
      'mytracks': {
        template:
          `<app-track-print track="$ctrl"></app-track-print>`
      }
    }
  }, {
    name: 'track-share',
    url: '/track-share',
    views: {
      'mytracks': {
        template:
          `<app-track-share></app-track-share>`
      }
    }
  }, {
    name: 'track-config',
    url: '/track-config',
    views: {
      'mytracks': {
        template:
          `<app-tracks-config
             on-config-changed="$ctrl.updateTrackProperties()"
             on-config-saved="$ctrl.updateFacts()"
             on-config-canceled="$ctrl.gotoTrackFacts()">
           </app-tracks-config>`
      }
    }
  }, {
    name: 'general-config',
    url: '/general-config',
    views: {
      'mytracks': {
        component: 'appConfigGeneral'
      }
    },
    resolve: {
      'userSettings': resolveUserSettings
    }
  }, {
    name: 'track-filter',
    url: '/track-filter',
    views: {
      'mytracks': {
        template:
          `<app-track-filters></app-track-filters>`
      }
    }
  }, {
    name: 'track-gpx',
    url: '/track-gpx',
    views: {
      'mytracks': {
        template:
          `<app-tracks-gpx></app-tracks-gpx>`
      }
    }
  }];

  // If the user enters a URL that doesn't match any known URL (state), send them to `/`
  $urlRouterProvider.otherwise('home');

  const states = [
    home,
    ...userRoutes,
    ...trackRoutes,
  ];

  states.forEach(state => {
    $stateProvider.state(state.name, state);
  });
};


export default router;
